import { connect } from 'react-redux'
import { DraggingHint } from 'aria-viewer/common'

const mapStateToProps = state => ({
    isVisible: state.getIn(['panorama', 'draggingHint', 'isVisible']),
    delay: state.getIn(['panorama', 'draggingHint', 'delay']),
    hintText: state.getIn(['panorama', 'draggingHint', 'hintText']),
    showAnimation: state.getIn(['device', 'isDeviceDesktop']),
})

export default connect(mapStateToProps)(DraggingHint)
